(function () {
  'use strict';

  angular
    .module('languageDiscrepancy')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('languageDiscrepancy', {
        url: '/language-discrepancy',
        views : {
          'languageDiscrepancyView' : {
            templateUrl: 'language-discrepancy/views/language-discrepancy.tpl.html',
            controller: 'LanguageDiscrepancyCtrl',
            controllerAs: 'languageDiscrepancy'
          }
        }

      });
  }
}());
